import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DESTINATIONS } from "../../lib/content";
import { Eyebrow } from "../Reveal";

export const Destinations = () => (
  <section id="destinations" data-testid="destinations" className="bg-secondary text-secondary-foreground py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
        <div>
          <Eyebrow className="text-primary">Featured destinations</Eyebrow>
          <h2 className="font-display text-5xl md:text-7xl font-light tracking-tight leading-[0.95] mt-4">
            Places groups
            <br />
            <span className="italic">love to gather.</span>
          </h2>
        </div>
        <p className="text-white/65 max-w-sm font-light leading-relaxed">
          A few favorites — but if your group has somewhere else in mind, we'll block it there too.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {DESTINATIONS.map((d, i) => (
          <motion.div
            key={d.city}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.1 }}
            className="group relative overflow-hidden h-[440px] border border-white/10"
          >
            <img
              src={d.img}
              alt={d.city}
              className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[900ms] ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent" />
            <div className="relative z-10 h-full flex flex-col justify-end p-6">
              <ArrowUpRight className="w-6 h-6 text-white/60 group-hover:text-primary transition-colors absolute top-6 right-6" />
              <h3 className="font-display text-white text-3xl font-light mb-2">{d.city}</h3>
              <p className="text-white/70 text-sm font-light leading-relaxed">{d.blurb}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
